import { useEffect } from "react";

import PC from "./pc";
import Mobile from "./mobile";

import { CommonRuntime, Platform, setRuntime } from "utils/runtime";
import { ParseProductTagFromUrlResp } from "utils/playground/url";
import { TPlayground, TModule } from "services/page/admin";
import { TFrontModule } from "services/page/app";

export interface MainProps {
	page: TPlayground;
	modules: TFrontModule[];
	frontModules: TModule[];
	tagQuery: ParseProductTagFromUrlResp;
	runtime: CommonRuntime;
}

export default function Main(props: MainProps) {
	const { runtime } = props;
	const { platform } = runtime;
	const isPC = platform === Platform.WEB;

	useEffect(() => {
		setRuntime(runtime);
	});
	return isPC ? <PC {...props} /> : <Mobile {...props} />;
}
